module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-braces-types"
  }, _vm._l((_vm.props), function(section, i) {
    return _c('div', {
      key: i,
      staticClass: "custom-braces-types__section",
      class: {
        "custom-braces-types__section--alt": i % 2
      }
    }, [(_vm.active <= i + 1) ? _c('Trigger', {
      staticClass: "custom-braces-types__trigger",
      attrs: {
        "props": i + 1
      }
    }) : _vm._e(), _c('div', {
      staticClass: "custom-braces-types__row"
    }, [_c('div', {
      staticClass: "custom-braces-types__col-1"
    }, [_c('div', {
      staticClass: "custom-braces-types__subtitle",
      class: {
        active: _vm.active >= i + 1
      },
      domProps: {
        "innerHTML": _vm._s(section.title)
      }
    }), (section.icon) ? _c('Icon', {
      staticClass: "custom-braces-types__icon",
      attrs: {
        "name": "section.icon"
      }
    }) : _vm._e(), _c('div', {
      staticClass: "custom-braces-types__tagline",
      domProps: {
        "innerHTML": _vm._s(section.sub_title)
      }
    }), _c('div', {
      staticClass: "custom-braces-types__content",
      domProps: {
        "innerHTML": _vm._s(section.body)
      }
    }), _c('div', {
      staticClass: "custom-braces-types__rectangle"
    })], 1), _c('div', {
      staticClass: "custom-braces-types__col-2"
    }, [_c('div', {
      staticClass: "custom-braces-types__image"
    }, [_c('div', {
      staticClass: "overlay",
      class: {
        active: _vm.active >= i + 1
      }
    }), _c('div', {
      staticClass: "image",
      style: ("backgroundImage: url(" + section.image + ");")
    })])])])], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-648aadc5","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-braces-types/custom-braces-types.pug
// module id = 646
// module chunks = 1